import React, { Tag } from 'tea-component';
import classNames from 'classnames';
import {
  PROGRESS_ENUM,
  PROGRESS_TEXT_COLOR,
  PROGRESS_TEXT_COLOR_BG_BLACK,
} from '@gp/constants/const';
import './index.scss';

function ProgressTag(props) {
  const { progress, type, className } = props;
  return (
    <>
      {(progress && PROGRESS_ENUM[progress]) && (
        <div
          className={classNames('dbg-tag', className)}
          style={{backgroundColor: type === 'GT' ? PROGRESS_TEXT_COLOR_BG_BLACK?.[PROGRESS_ENUM?.[progress]]?.bgColor : PROGRESS_TEXT_COLOR?.[PROGRESS_ENUM?.[progress]]?.bgColor}}
        >
          <span
            className='dbg-tag-text'
            style={{color: type === 'GT' ? PROGRESS_TEXT_COLOR_BG_BLACK?.[PROGRESS_ENUM?.[progress]]?.color : PROGRESS_TEXT_COLOR?.[PROGRESS_ENUM?.[progress]]?.color}}
          >
            {PROGRESS_ENUM[progress]}
          </span>
        </div>
      )}
    </>
  );
}

export default ProgressTag;
